import { render, staticRenderFns } from "./userManageSearch.vue?vue&type=template&id=2880e80f&scoped=true&"
import script from "./userManageSearch.vue?vue&type=script&lang=js&"
export * from "./userManageSearch.vue?vue&type=script&lang=js&"
import style0 from "./userManageSearch.vue?vue&type=style&index=0&id=2880e80f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880e80f",
  null
  
)

export default component.exports